import {
    useMemo,
} from 'react'
import StatusHandler from 'app/shared-components/StatusHandler'
import {
    ArchiveButton,
    useArchive,
    ArchiveConfirmationDialog,
} from 'app/shared-components/Archive'
import useGetContact from 'app/Apps/ContactManagement/Contacts/hooks/useGetContact'
import {
    generateSkyNetLink,
} from 'app/SkyNetRoutes'
import useRelationshipsManagementRoutes from 'app/SkyNetRoutes/hooks/useRelationshipsManagementRoutes'
import request from 'app/requests/Engagement.requests'
import {
    WithId,
} from 'app/types/common.types'

import EngagementForm from '../EngagementForm'
import useGetEngagement from '../hooks/useGetEngagement'

const EngagementUpdate = ({
    id,
}: Readonly<WithId<number>>) => {
    const {
        Engagements: EngagementsRoutes,
    } = useRelationshipsManagementRoutes()
    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    } = useGetEngagement(id)

    const {
        data: contact,
    } = useGetContact(data?.contact?.id)

    const archive = useArchive({
        requestParamFn: data?.archived ? request.restore
            : request.archive,
        notificationId: 'EngagementUpdate',
        title: 'Engagement',
        data,
        redirectionAfterSuccess: generateSkyNetLink({
            domainPath: contact?.isProspect
                ? EngagementsRoutes.path : EngagementsRoutes.Contacts.path,
        }),
    })

    const customButtons = useMemo(() => {
        return [<ArchiveButton
            onClick={archive.handleArchiveRestore}
            archived={data?.archived}
        />]
    }, [
        archive,
        data?.archived,
    ])

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <>
                <EngagementForm
                    requestParam={request.update({
                        id,
                    })}
                    data={data}
                    onSuccess={invalidate}
                    onCancel={invalidate}
                    customButtons={customButtons}
                />
                <ArchiveConfirmationDialog
                    title="Engagement"
                    openConfirmDialog={archive.openConfirmDialog}
                    handleClose={archive.handleArchiveRestoreConfirm}
                    archived={data?.archived}
                />
            </>
        </StatusHandler>
    )
}

export default EngagementUpdate
